import gql from 'graphql-tag';
import AuthUserFragment from 'containers/Auth/graphql/userFragment.gql';

export default gql`
  query User {
    user {
      ...AuthUserFragment
    }
  }
  ${AuthUserFragment}
`;



// WEBPACK FOOTER //
// ./app/components/BaseLayout/graphql/userQuery.gql.js